import { render, staticRenderFns } from "./MidwifeContactOverview.vue?vue&type=template&id=9ff24d8a"
import script from "./MidwifeContactOverview.vue?vue&type=script&lang=js"
export * from "./MidwifeContactOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports